
const RECENT_LOCATIONS_KEY = 'recent_locations';
const MAX_RECENT = 5;

export function getRecentLocations() {
  return JSON.parse(localStorage.getItem(RECENT_LOCATIONS_KEY)) || [];
}

export function addRecentLocation(location) {
  let recents = getRecentLocations();
  // Remove duplicates (by name or lat/lng)
  recents = recents.filter(
    loc => loc.name !== location.name || loc.latitude !== location.latitude || loc.longitude !== location.longitude
  );
  recents.unshift(location); // Add to front
  recents = recents.slice(0, MAX_RECENT); // Limit to MAX_RECENT
  localStorage.setItem(RECENT_LOCATIONS_KEY, JSON.stringify(recents));
}